import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { get, img } from "@/lib/api";

export default function Articles() {
  const [cat, setCat] = useState("");
  const { data: all = [] } = useQuery({ queryKey: ["articles"], queryFn: () => get("/articles") });
  const cats = [...new Set(all.map((a) => a.category))];
  const list = cat ? all.filter((a) => a.category === cat) : all;
  const [lead, ...rest] = list;

  return (
    <div data-testid="articles-page">
      <Seo title="HOA Articles & Guides" description="Guides on HOA fees, pet rules, rental restrictions and buying in an HOA community." path="/articles" />
      <PageHeader eyebrow="Articles & guides" title="Understand your HOA" subtitle="Plain-English guides to fees, rules and what to ask before you buy." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
        <div className="flex flex-wrap gap-2 mb-6 sm:mb-10" role="group" aria-label="Filter by category">
          {["", ...cats].map((c) => (
            <button key={c || "all"} onClick={() => setCat(c)} aria-pressed={cat === c} data-testid={`article-cat-${c || "all"}`}
              className={`rounded-full px-4 py-2 text-sm font-semibold border transition-colors ${cat === c ? "bg-[#0B2150] text-white border-[#0B2150]" : "bg-white text-[#0B2150] hover:bg-slate-100"}`}>{c || "All"}</button>
          ))}
        </div>
        {lead && (
          <Link to={`/articles/${lead.slug}`} className="group grid lg:grid-cols-2 gap-5 sm:gap-8 mb-8 sm:mb-14" data-testid={`article-card-${lead.slug}`}>
            <div className="overflow-hidden rounded-3xl h-72 lg:h-96"><img src={img(lead.image)} alt="" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
            <div className="flex flex-col justify-center">
              <p className="eyebrow">{lead.category}</p>
              <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#0B2150] group-hover:underline">{lead.title}</h2>
              <p className="mt-4 text-slate-600 text-base">{lead.excerpt}</p>
            </div>
          </Link>
        )}
        <div className="grid gap-6 sm:gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((a) => (
            <Link key={a.slug} to={`/articles/${a.slug}`} className="group" data-testid={`article-card-${a.slug}`}>
              <div className="overflow-hidden rounded-2xl h-52"><img src={img(a.image)} alt="" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
              <p className="mt-4 text-xs font-semibold uppercase tracking-wider text-[#027A6D]">{a.category}</p>
              <h3 className="mt-1 text-lg font-semibold text-[#0B2150] group-hover:underline">{a.title}</h3>
              <p className="mt-1 text-sm text-slate-600 line-clamp-2">{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
